<!--#region boutons sauvegarde, recherche, filtres avancés, rtour-->
<div class="row align-items-center">
  <button [disabled]="!ListResas || ListResas.length == 0" (click)="OnSave()" class="ml-3 col-auto q-btn q-main">
    <i class="fas" [ngClass]="[isLoading ? 'fa-spin fa-spinner fa-pulse' : 'fa-save']"></i>
  </button>
  <button (click)="OnSearch()" class="col-auto q-btn q-white"><i class="fas fa-search"></i></button>
  <button title="filtres avancés" class="q-btn q-white col-auto" (click)="displayBo = !displayBo"><i class="fas fa-filter" [ngClass]="{'q-c-main': displayBo}"></i></button>
  <div class="col"></div>
  <i class="fas q-c-danger fa-undo q-pointer" (click)="Undo()"></i>
</div>
<!--#endregion-->

<!--#region filtres-->
<div class="row align-items-center mt-2">
  <div class="col-auto">Bureau :</div>
  <select class="ml-3 q-main-select col-auto" [(ngModel)]="idBureau">
    <option *ngFor="let bureau of planningService.ListeBureaux" [value]="bureau.id">{{bureau.value}}</option>
  </select>
</div>

<div class="row align-items-center mt-2">
  <div class="col-auto">Date de début comprise entre :</div>
  <q-date style="width: 150px;" [(ngValue)]="dateDebut" class="col-auto"></q-date>
  <q-date style="width: 150px;" [(ngValue)]="dateFin" class="col-auto ml-1"></q-date>
</div>
<!--#endregion-->

<!--#region bo et grid-->
<div [ngClass]="{'d-none' : !displayBo}" class="row">
  <q-bodisplay #boFind class="col my-3" [modeBo]="modeBo.Find" [item]="modelBo" (sendFilter)="getFilter()"></q-bodisplay>
</div>
<div *ngIf="displayGrid" class="row mt-2">
  <q-customgrid class="col"
                [customgridName]="customgridName"
                [completeWhere]="strWhere"
                [(refreshData)]="refreshData"
                (selectChanged)="selectLine($event)"
                (gridReady)="onGridReady($event)">

  </q-customgrid>
</div>
<!--#endregion-->
